import { Services, getServiceNameKebabCase, getServiceNameViaPoint, integerMaskOptions } from '@sigma-frontend-libs/commons'

import { components, icons, popperPlacements } from '@/utils'

import info from '@/components/info'
import sticker from '@/components/sticker'
import validationInfo from '@/components/validationInfo'

const serviceNameViaPoint = getServiceNameViaPoint(Services['url-shortener'])
const serviceNameKebabCase = getServiceNameKebabCase(Services['url-shortener'])

function renderActivator(h) {
  return h(
    sticker,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.titles.additional`),
        label: this.getTranslate(`${serviceNameViaPoint}.hints.additional`),
        color: this.$_color,
        icon: icons.settings,
        clickable: true,
        width: '100%'
      },
      slot: 'activator'
    }
  )
}
function renderExpireAfterHrsField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.expireAfterHrs,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.expireAfterHrs`),
        suffix: this.getTranslate('time.hour'),
        maskOptions: integerMaskOptions,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.expireAfterHrs = this.nullableNumber(event)
        }
      }
    }
  )
}
function renderDeleteAfterExpireDaysField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.deleteAfterExpireDays,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.deleteAfterExpireDays`),
        suffix: this.getTranslate('time.day'),
        maskOptions: integerMaskOptions,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.deleteAfterExpireDays = this.nullableNumber(event)
        }
      }
    }
  )
}
function renderExpireUrlField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.expireUrl,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.expireUrl`),
        validateOnBlur: true,
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.expireUrl = this.nullableString(event)
        }
      }
    }
  )
}
function renderValidationInfo(h) {
  return h(
    validationInfo,
    {
      props: {
        value: this.validationGroups
      }
    }
  )
}
function renderDescription(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.infos.expire`)
      }
    }
  )
}
function renderParamsContent(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-additional`
    },
    [
      renderExpireAfterHrsField.call(this, h),
      renderDeleteAfterExpireDaysField.call(this, h),
      renderExpireUrlField.call(this, h),
      renderValidationInfo.call(this, h),
      renderDescription.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components.menu,
    {
      props: {
        closeOnContentClick: false,
        offsetDistance: 8,
        placement: popperPlacements['bottom-start'],
        sameWidth: true,
        rounded: true
      }
    },
    [
      renderActivator.call(this, h),
      renderParamsContent.call(this, h)
    ]
  )
}
